<template>
    <footer class="bg-dark text-white py-6">
      <div class="container mx-auto px-4 text-center">
        <p>密码管理器 &copy; 2026 - 安全管理您的账号信息</p>
        <p class="text-sm text-gray-400 mt-2">数据存储在本地，请注意保护您的设备安全</p>
      </div>
    </footer>
</template>

<script setup>

</script>

<style scoped>
/* 组件的样式 */
</style>
